import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-covid-assessment',
  templateUrl: './covid-assessment.component.html',
  styleUrls: ['./covid-assessment.component.css']
})
export class CovidAssessmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
